import { createContext } from 'react';

export const MonitorContext = createContext(null);
